import { useMemo } from "react";
import useSession from "./session.hook";
import { OrgType } from "Data/org-type";
import { first } from "lodash";

export default function useCorporateType() {
  const { roles } = useSession();

  const result = useMemo(() => {
    const firstRole: any = first(roles) || {};

    const allCorporateTypes = firstRole?.type;

    return {
      allCorporateTypes,

      isOwner: allCorporateTypes === OrgType.OWNER ? true : false,
      isLogisticProvider:
        allCorporateTypes === OrgType.LOGISTIC_PROVIDER ? true : false,
      isCompany: allCorporateTypes === OrgType.COMPANY ? true : false,
      isCustomer: allCorporateTypes === OrgType.CUSTOMER ? true : false,
    };
  }, [JSON.stringify([roles])]);

  return result;
}
